import Reveal from "@/components/Reveal";
import Footer from "@/components/Footer";

const STRUKTUR_IMG = "/struktur-ppid.png";

export default function StrukturPpid() {
  return (
    <div className="min-h-screen bg-white text-[#0B2440] antialiased">
      <main className="px-6 pb-20 pt-28 md:px-12 md:pt-32">
        <Reveal>
          <p className="inline-flex items-center gap-2 text-[11px] font-bold uppercase tracking-[0.14em] text-[#1479BF]">
            <span
              aria-hidden="true"
              className="h-1.5 w-1.5 rounded-full bg-[#E8A33D]"
            />
            Profil PPID — Struktur Organisasi
          </p>
          <h1 className="mt-6 font-display text-4xl font-semibold leading-[1.05] text-[#0B2440] md:text-6xl">
            Struktur PPID LLDIKTI Wilayah VII
          </h1>
          <div className="mt-6 h-1.5 w-20 rounded-full bg-[#E8A33D]" />
        </Reveal>

        <Reveal delay={0.15}>
          <div className="mx-auto mt-12 max-w-3xl overflow-hidden rounded-3xl border border-[#E3EBF3] bg-white">
            <img
              src={STRUKTUR_IMG}
              alt="Struktur Organisasi PPID LLDIKTI Wilayah VII"
              data-testid="struktur-ppid-image"
              className="h-auto w-full"
            />
          </div>
        </Reveal>
      </main>
      <Footer compact />
    </div>
  );
}
